import { HttpContextToken } from '@angular/common/http';

/**
 * Object keys whose `null` values must be preserved (i.e. NOT stripped) from a write request body.
 *
 * The application-level interceptor that removes `null`/`NaN` values from planning-projects
 * PATCH/PUT/POST payloads reads this token from the request `HttpContext`. Any key listed here
 * keeps its explicit `null`, which is required to intentionally clear an optional backend field.
 */
export const PRESERVE_NULL_KEYS = new HttpContextToken<string[]>(() => []);
